import React from 'react';
import { pddServiceLine, pddRoot } from '../../../../utils/defaultValues';
import AssetsOverview from '../../../tdd-module/feature-bundle/asset-management/AssetsOverview';
import { Box } from '@mui/material';

const AssetOverviewHome = () => {
  return (
    <Box
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', height: '100%' }}
    >
      <AssetsOverview serviceLine={pddServiceLine} routePrefix={pddRoot} />
    </Box>
  );
};
export default AssetOverviewHome;
